/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import Page from "@insite/mobius/Page";
import * as React from "react";
import { ReactNode } from "react";
import { css } from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    // xng-change: update css for the page that wrap breadcrumbs
    return (
        <>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page
                    as="div"
                    css={css`
                        overflow: visible !important;
                    `}
                >
                    <PageBreadcrumbs />
                </Page>
            )}
            {pageContent}
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
            <CookiePrivacyPolicyPopup />
        </>
    );
};

export default PageLayout;
